import { Link } from 'react-router-dom';
import AdSlot from '../AdSlot';

function HowTo() {
  return (
    <div className="app">
      <AdSlot slot="XXXXXXXXXX" format="horizontal" className="ad-top" />

      <div className="container page-content">
        <Link to="/" className="back-link">&larr; Back to Downloader</Link>

        <h1 className="page-title">How to Download Videos Online</h1>
        <p className="page-subtitle">Download videos from YouTube, Twitter, Instagram, TikTok and Facebook in just 3 simple steps.</p>

        <div className="steps">
          <div className="step">
            <span className="step-number">1</span>
            <h3>Copy the Video URL</h3>
            <p>Go to YouTube, Twitter, Instagram, TikTok or Facebook. Find the video you want to download and copy its URL from the address bar or share button.</p>
          </div>

          <div className="step">
            <span className="step-number">2</span>
            <h3>Paste & Click Download</h3>
            <p>Come back to HD Video Download and paste the URL into the input field. You can also click the "Paste" button to automatically paste from your clipboard. Then click "Download".</p>
          </div>

          <div className="step">
            <span className="step-number">3</span>
            <h3>Choose Quality & Save</h3>
            <p>Select your preferred quality (from 240p to 4K) and format (MP4 or MP3). The file will be downloaded directly to your device.</p>
          </div>
        </div>

        <h2 className="section-title">Supported Platforms</h2>
        <div className="platform-list">
          <div className="platform-item">
            <h3>YouTube</h3>
            <p>Download YouTube videos in MP4 format up to 4K resolution, or extract audio as MP3. Works with regular videos, shorts, and music videos.</p>
          </div>
          <div className="platform-item">
            <h3>Twitter / X</h3>
            <p>Save Twitter videos and GIFs directly to your device. Supports all video qualities available on the platform.</p>
          </div>
          <div className="platform-item">
            <h3>Instagram</h3>
            <p>Download Instagram Reels, IGTV videos, and video posts. Public accounts only — private account videos cannot be downloaded.</p>
          </div>
          <div className="platform-item">
            <h3>TikTok</h3>
            <p>Save TikTok videos without watermark in high quality. Works with any public TikTok video link.</p>
          </div>
          <div className="platform-item">
            <h3>Facebook</h3>
            <p>Download Facebook videos from public posts, pages, and groups. Supports HD quality when available.</p>
          </div>
        </div>

        <h2 className="section-title">Content Policy</h2>
        <p style={{color:'var(--text-secondary)', lineHeight:'1.7', marginBottom:'2rem'}}>
          HD Video Download is intended for downloading publicly available videos from mainstream social media platforms for personal use only.
          We do <strong>not</strong> support or allow downloading of adult, explicit, or age-restricted content.
          Users are responsible for respecting copyright laws and the terms of service of each platform.
        </p>

        <div className="cta-section">
          <Link to="/" className="cta-btn">Start Downloading Now</Link>
        </div>
      </div>

      <AdSlot slot="XXXXXXXXXX" format="horizontal" className="ad-bottom" />

      <footer className="footer">
        <span>&copy; {new Date().getFullYear()} hdvideodownload.com — All rights reserved.</span>
        <a href="mailto:hdvideodownload44@gmail.com" className="footer-mail">hdvideodownload44@gmail.com</a>
      </footer>
    </div>
  );
}

export default HowTo;
